import { useState } from "react"
import PropTypes from "prop-types"

import logIFTTTNextAction from "app/lib/ifttt_next_log_action"

import { updateApplet } from "./api"

import PushNotifications from "./config/push_notifications"
import { Activity, RecentActivity } from "./config/activity"

const TopLevelConfig = ({ applet, user, urls, showPublishCta }) => {
  const { id: appletId, can_push_enable, push_enabled } = applet
  const [pushEnabled, setPushEnabled] = useState(push_enabled)

  const onPushChange = async pushEnabled => {
    logAction(
      `connection_${pushEnabled ? "enable" : "disable"}_push_notification`
    )
    await updateApplet({ appletId, pushEnabled })

    setPushEnabled(pushEnabled)
  }

  function logAction(type) {
    logIFTTTNextAction("click", {
      location_type: "connection_config",
      object_id: appletId,
      object_type: type,
    })
  }

  return (
    <>
      <RecentActivity connection={applet} />
      {applet.status == "enabled_for_user" && can_push_enable && (
        <PushNotifications onChange={onPushChange} pushEnabled={pushEnabled} />
      )}

      <Activity
        connection={applet}
        activityURL={urls.activityPath}
        checkConnectionURL={urls.checkConnectionPath}
        userTier={user.tier}
      />

      {showPublishCta ? (
        <div className="connection-view-activity">
          <div className="connection-list-activity">
            <p className="txt-body-3">
              Publish this Applet so anyone can use it.
            </p>

            <a
              role="button"
              className="button-tertiary button-outlined"
              href={urls.publishedAppletEditPath}
              data-track-ifttt-next-event="click"
              data-track-data={JSON.stringify({
                object_type: "publish_this_applet",
                location_type: "connection",
              })}
            >
              Publish
            </a>
          </div>
        </div>
      ) : null}
    </>
  )
}

TopLevelConfig.propTypes = {
  applet: PropTypes.shape({
    id: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    author: PropTypes.string.isRequired,
    can_push_enable: PropTypes.bool.isRequired,
    author_id: PropTypes.string,
    push_enabled: PropTypes.bool,
  }).isRequired,
  user: PropTypes.shape({
    login: PropTypes.string.isRequired,
    tier: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
  }).isRequired,
  urls: PropTypes.shape({
    activityPath: PropTypes.string.isRequired,
    checkConnectionPath: PropTypes.string.isRequired,
    publishedAppletEditPath: PropTypes.string,
  }).isRequired,
  showPublishCta: PropTypes.bool.isRequired,
}

export default TopLevelConfig
